import React from "react";
import { Row, Col, Button, ProgressBar } from "react-bootstrap";

interface Props {
  id?: string;
  children?: React.ReactNode;
  headerIcon: string;
  headerText: string;
  saveText?: string;
  deleteText?: string;
  headerActionContent?: React.ReactNode;
  cancelFunction?: () => void;
  deleteFunction?: () => void;
  saveFunction?: () => void;
  className?: string;
  isSubmitting?: boolean;
  ariaLabelDelete?: string;
  ariaLabelSave?: string;
  submitProgress?: number;
}

export const InputBox: React.FC<Props> = (props: Props) => {
  let leftButtons = [];
  let rightButtons = [];

  // Delete button goes on the left
  if (props.deleteFunction) {
    leftButtons.push(
      <Button
        key="delete"
        id="delete"
        data-testid="delete-button"
        variant="link"
        className="delete-action-btn"
        aria-label={props.ariaLabelDelete || props.deleteText || "Delete"}
        onClick={props.deleteFunction}
        disabled={props.isSubmitting}
      >
        <i className="fas fa-trash-alt" aria-hidden="true"></i> {props.deleteText || "Delete"}
      </Button>
    );
  }

  // Cancel and Save buttons go on the right
  if (props.cancelFunction) {
    rightButtons.push(
      <Button
        key="cancel"
        data-testid="cancel-button"
        variant="outline-secondary"
        onClick={props.cancelFunction}
        disabled={props.isSubmitting}
        style={{marginRight: '8px'}}
      >
        Cancel
      </Button>
    );
  }

  if (props.saveFunction) {
    if (props.submitProgress && props.submitProgress > 0 && props.submitProgress < 100) {
      rightButtons.push(<ProgressBar key="progress" striped animated variant="success" now={props.submitProgress} aria-label={`Saving progress: ${props.submitProgress}%`} aria-valuenow={props.submitProgress} aria-valuemin={0} aria-valuemax={100} style={{width: '200px'}} />);
    } else {
      rightButtons.push(
        <Button
          key="save"
          data-testid="save-button"
          type="submit"
          variant="primary"
          aria-label={props.ariaLabelSave || props.saveText || "Save"}
          onClick={props.saveFunction}
          disabled={props.isSubmitting}
        >
          {props.saveText || "Save"}
        </Button>
      );
    }
  }

  let classNames = ["inputBox"];
  if (props.className) classNames.push(props.className);

  return (
    <div id={props.id} className={classNames.join(" ").trim()} role="region" aria-label={props.headerText}>
      <div className="header" data-cy="header">
        <Row>
          <Col xs={6}><i className={props.headerIcon} aria-hidden="true"></i> {props.headerText}</Col>
          <Col xs={6} style={{ textAlign: "right" }}>{props.headerActionContent}</Col>
        </Row>
      </div>
      <div className="content">{props.children}</div>
      <div className="footer" role="group" aria-label="Form actions">
        <div className="footer-left">{leftButtons}</div>
        <div className="footer-right">{rightButtons}</div>
      </div>
    </div>
  );
}